import { type RequestPayload, router } from "@inertiajs/core";

import { TermsOfUseForm } from "../../components/termsOfUse/TermsOfUseForm";
import { ContentShell } from "../../layout/ContentShell";
import { terms_of_uses_path } from "../../routes";

export default function TermsOfUseAccept() {
  const onSubmit = (values: RequestPayload) => router.post(terms_of_uses_path(), values);

  return (
    <ContentShell title="Nutzungsbedingungen" center>
      <TermsOfUseForm onSubmit={onSubmit} />
    </ContentShell>
  );
}
